<div class="main-container" style="margin: auto">
    <div class="row page-header-actions">
        <button mat-icon-button [routerLink]="['/flujo-credito-light/seleccion-modelo']"
            matTooltip="Volver a Selección de modelo">
            <mat-icon>arrow_back</mat-icon>
        </button>
    </div>

    <div class="page-content">
        <h1 class="mat-section-title">Flujo de Crédito Light</h1>
        <label class="mat-sub-title mb-5" for="">Listado de solicitudes</label>

        <div class="mb-5">
            <mat-accordion>
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>Filtros</mat-panel-title>
                    </mat-expansion-panel-header>
                    <div [formGroup]="filtersForm" class="row g-3">
                        <div class="col-lg-4 col-md-6 col-sm-6 mt-4">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Rut</mat-label>
                                <input matInput formControlName="rut" type="text" mask="00000000" [validation]=false/>
                            </mat-form-field>
                        </div>

                        <div class="col-lg-4 col-md-6 col-sm-6 mt-4">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Nombre</mat-label>
                                <input matInput formControlName="name" type="text" />
                            </mat-form-field>
                        </div>

                        <div class="col-lg-4 col-md-6 col-sm-6 mt-4">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>ID Transacción</mat-label>
                                <input matInput formControlName="idTransaccion" type="text" />
                            </mat-form-field>
                        </div>

                        <div class="col-lg-4 col-md-6 col-sm-6 mt-4">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Estado transacción</mat-label>
                                <mat-select formControlName="transactionStatus">
                                    <mat-option value="">-</mat-option>
                                    <mat-option *ngFor="let status of transactionStatuses" [value]="status.key">
                                        {{ status.displayName | titlecase }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <div class="col-lg-4 col-md-6 col-sm-6 mt-4">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Decisión</mat-label>
                                <mat-select formControlName="decision">
                                    <mat-option value="">-</mat-option>
                                    <mat-option *ngFor="let decision of decisions" [value]="decision.key">
                                        {{ decision.displayName }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <div class="col-md-4 col-sm-12 mt-4">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Fecha</mat-label>
                                <input matInput [matDatepicker]="picker" formControlName="dateReport" />
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>
                        </div>

                        <div class="col-lg-4 col-md-6 col-sm-6 mt-4">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Automática</mat-label>
                                <mat-select formControlName="isAutomaticDecision">
                                    <mat-option value="">-</mat-option>
                                    <mat-option value="true">Sí</mat-option>
                                    <mat-option value="false">No</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <div class="col-lg-4 col-md-6 col-sm-6 mt-4">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Finalizada</mat-label>
                                <mat-select formControlName="isClosed">
                                    <mat-option value="">-</mat-option>
                                    <mat-option value="true">Sí</mat-option>
                                    <mat-option value="false">No</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    
                    <div class="row justify-content-end">
                        <div *ngIf="!isFilterActive" class="col-md-2 col-sm-12 mt-4">
                            <button mat-flat-button color="primary" (click)="applyFilters()" class="mt-3 w-100">
                                <mat-icon class="scale-150">search</mat-icon>
                                Buscar
                            </button>
                        </div>
                        <div *ngIf="isFilterActive" class="col-md-2 col-sm-12 mt-4">
                            <button mat-stroked-button color="warn" (click)="clearFilters()" class="mt-3 w-100">
                                <mat-icon class="scale-150">close</mat-icon>
                                Limpiar filtros
                            </button>
                        </div>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </div>

        <div class="mat-table-container" (scroll)="onTableScroll($event)">
            <table mat-table [dataSource]="dataSource">
                <mat-text-column name="rut"></mat-text-column>
                <mat-text-column name="nombre"></mat-text-column>
                <mat-text-column name="idTransaccion" headerText="ID transacción"></mat-text-column>

                <ng-container matColumnDef="decision">
                    <th mat-header-cell *matHeaderCellDef>Decisión</th>
                    <td mat-cell *matCellDef="let element">
                        <mat-chip *ngIf="element.decision" appereance="outline" color="primary"
                            class="{{ getDecisionBackgroundColorClass(element.decision) }}">
                            {{ element.decision }}
                        </mat-chip>
                    </td>
                </ng-container>

                <ng-container matColumnDef="estado">
                    <th mat-header-cell *matHeaderCellDef>Estado</th>
                    <td mat-cell *matCellDef="let element">
                        <mat-chip appereance="outline" color="primary"
                            class="color-{{ element.estado.toLowerCase() }} status-chip">
                            {{ getStatusLabel(element.estado) }}
                        </mat-chip>
                    </td>
                </ng-container>

                <ng-container matColumnDef="fecha">
                    <th mat-header-cell *matHeaderCellDef>Fecha</th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.fecha | date : "dd MMMM yyyy" }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="auto">
                    <th mat-header-cell *matHeaderCellDef>Auto</th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.auto ? "Sí" : "No" }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="estaCerrada">
                    <th mat-header-cell *matHeaderCellDef>Finalizada</th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.estaCerrada ? "Sí" : "No" }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="acciones">
                    <th mat-header-cell *matHeaderCellDef>Acciones</th>
                    <td mat-cell *matCellDef="let element">
                        <button
                            *ngIf="canStartApprovalFlow(element)"
                            mat-icon-button
                            [routerLink]="['/flujo-credito-light', element.idTransaccion, 'flujo-aprobacion']"
                            matTooltip="Iniciar flujo de aprobación" 
                            [matTooltipPosition]="'right'">
                            <mat-icon>arrow_forward</mat-icon>
                        </button>
                    </td>
                </ng-container>

                <ng-container matColumnDef="progress">
                    <th mat-cell *matCellDef="let element"></th>
                    <td mat-header-cell *matHeaderCellDef [attr.colspan]="displayedColumns.length">
                        <mat-progress-bar *ngIf="isLoadingResults" mode="indeterminate"></mat-progress-bar>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-header-row *matHeaderRowDef="['progress']; sticky: true" class="progress-row"></tr>
                <tr
                    *matRowDef="let row; columns: displayedColumns"
                    mat-row
                    [class.cursor-pointer]="canViewClientCard(row)"
                    (click)="canViewClientCard(row) && viewClientCard(row)">
                </tr>

                <ng-container *ngIf="!isLoadingResults">
                    <tr class="mat-mdc-row" *matNoDataRow>
                        <td class="mat-mdc-cell text-center font-weight-500" [attr.colspan]="displayedColumns.length">
                            No hay datos disponibles
                        </td>
                    </tr>
                </ng-container>
            </table>
        </div>
    </div>
</div>